import SummaryStep from "components/steps/SummaryStep";

const FavPlanSummaryStep = () => <SummaryStep />;

export default FavPlanSummaryStep;
